import styled, { keyframes } from "styled-components";

import spinnerIcon from "assets/images/spinner.png";
import loader from "assets/images/loader.gif";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 5.6rem;
  width: 4.8rem;
  background-color: #ffffff;
  margin: auto;

  &.cover {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 100vh;
  }

  .gif {
    height: 48px;
  }
`;

const spin = keyframes`
  from {
    transform: rotateZ(0deg);
  }

  to {
    transform: rotateZ(360deg);
  }
`;

const Spinner = styled.img`
  height: 24px;
  width: 24px;
  animation: ${spin} 0.5s linear infinite;
`;

const Loader = ({ className, type }) => {
  if (type === "spinner") return <Spinner className={className} src={spinnerIcon} alt="spinner" />

  return (
    <Wrapper className={className}>
      <img src={loader} alt="loader" className="gif" />
    </Wrapper>
  );
};

export default Loader;
